module.exports = __webpack_public_path__ + "static/media/2_PoAs-116-ZPPCK_Formoplast_20150925.23e68f22.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/2_PoAs-116-ZPPCK_Formoplast_20150925.pdf
// module id = 176
// module chunks = 0